import { Minus, Plus } from "lucide-react";

/**
 * Numeric stepper: − [N] + (Booking.com style large round buttons).
 *
 * Props:
 *   value, onChange(n)
 *   min (default 0), max (default 20), step (default 1)
 *   label (optional, rendered above the stepper)
 *   dataTestid
 */
export default function CountStepper({ value, onChange, min = 0, max = 20, step = 1, label, dataTestid, className = "" }) {
  const dec = () => onChange(Math.max(min, (value || 0) - step));
  const inc = () => onChange(Math.min(max, (value || 0) + step));
  const atMin = (value || 0) <= min;
  const atMax = (value || 0) >= max;

  return (
    <div className={className}>
      {label && <div className="text-[10px] uppercase tracking-widest text-[#635F59] font-semibold mb-1.5">{label}</div>}
      <div className="inline-flex items-center gap-3" data-testid={dataTestid}>
        <button
          type="button"
          onClick={dec}
          disabled={atMin}
          aria-label="Diminuisci"
          data-testid={dataTestid ? `${dataTestid}-dec` : undefined}
          className={`w-10 h-10 rounded-full border-2 flex items-center justify-center transition ${atMin ? "border-[#E8E2D9] text-[#C9C2B6] cursor-not-allowed" : "border-[#1E3A5F] text-[#1E3A5F] hover:bg-[#1E3A5F] hover:text-white"}`}
        >
          <Minus className="w-4 h-4" />
        </button>
        <span className="font-display text-xl text-[#1E3A5F] min-w-[28px] text-center tabular-nums" data-testid={dataTestid ? `${dataTestid}-value` : undefined}>{value || 0}</span>
        <button
          type="button"
          onClick={inc}
          disabled={atMax}
          aria-label="Aumenta"
          data-testid={dataTestid ? `${dataTestid}-inc` : undefined}
          className={`w-10 h-10 rounded-full border-2 flex items-center justify-center transition ${atMax ? "border-[#E8E2D9] text-[#C9C2B6] cursor-not-allowed" : "border-[#1E3A5F] text-[#1E3A5F] hover:bg-[#1E3A5F] hover:text-white"}`}
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
